import * as Yup from 'yup';

export const validatePartner = Yup.object().shape({
	id: Yup.string()
		.required('Het ID veld is verplicht').matches(/^\w+$/, 'Het ID veld met alleen letters, cijfers, en underscores ( _ ) bevatten'),
	name: Yup.string()
		.required('Het naam veld is verplicht'),
});
